import { Link, Text, View } from '@react-pdf/renderer';
import React from "react";
import styles from "./styles";

const PDFFooter: React.FC<{}> = () => {
    return (<>
        <View style={styles.footer} fixed>
            <View style={styles.bottomDivider} />
            <View style={styles.footerSub}>
                <Text style={styles.footerText}>
                    {'AI-native workflow builder for investors.'}
                </Text>
                <View style={styles.footerLeft}>
                    <Text style={styles.footerSignup}>
                        {'Learn more at '}
                    </Text>
                    <Link src={'https://notissia.com'}>
                        <Text style={styles.footerLink}>
                            {'notissia.com'}
                        </Text>
                    </Link>
                </View>
            </View>
        </View>
    </>);
}

export default PDFFooter;